<template>
  <transition name="fade">
    <div class="level3-modal-container" v-if="subKbliEdit">
      <div class="lv3-title-text">Kegiatan Usaha Utama</div>
      <div class="lv3-edit-form">
        <div class="one-line-form">
          <div class="one-line-label">Kode</div>
          <input
            class="one-line-input"
            :placeholder="kode"
            type="text"
            v-model="kode"
            disabled
          />
        </div>
        <div class="one-line-form">
          <div class="one-line-label">Judul</div>
          <textarea
            class="one-line-input"
            :placeholder="title"
            type="text"
            v-model="title"
            disabled
          />
        </div>
        <div class="one-line-form">
          <div class="one-line-label">NIB</div>
          <div class="one-line-form">
            <input
              class="one-line-input"
              :value="nib"
              type="checkbox"
              v-model="nib"
            />
            <div>{{ nib ? 'Ya' : 'Tidak' }}</div>
          </div>
        </div>
        <div class="one-line-form">
          <div class="one-line-label">SS IZIN</div>
          <div class="one-line-form">
            <input
              class="one-line-input"
              :value="ss_izin"
              type="checkbox"
              v-model="ss_izin"
            />
            <div>{{ ss_izin ? 'Ya' : 'Tidak' }}</div>
          </div>
        </div>
        <div class="one-line-form">
          <div class="one-line-label">Izin Dokumen Lainnya</div>
          <div class="one-line-form">
            <input
              class="one-line-input"
              :value="dokumen_lainnya"
              type="checkbox"
              v-model="dokumen_lainnya"
            />
            <div>{{ dokumen_lainnya ? 'Ya' : 'Tidak' }}</div>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="deleteItem()">DELETE</div>
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="confirm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      id: '',
      vendor_id: '',
      kode: '',
      title: '',
      nib: false,
      ss_izin: false,
      dokumen_lainnya: false,
    }
  },
  computed: {
    subKbliEdit: function() {
      if (this.propsData) {
        let data = this.propsData

        this.id = data.id
        this.vendor_id = data.vendor_id
        this.kode = data.kbli_sub.kode
        this.title = data.kbli_sub.desc
        this.nib = data.nib
        this.ss_izin = data.ss_izin
        this.dokumen_lainnya = data.dokumen_lainnya
      }

      return this.$store.state.addEdit.subKbliEdit
    },
  },
  methods: {
    closeModal() {
      this.$store.commit('addEdit/ADD_EDIT_MODAL', {
        name: 'subKbliEdit',
        status: false,
      })
    },
    async confirm() {
      let updateData = {
        id: this.id,
        nib: this.nib,
        ss_izin: this.ss_izin,
        dokumen_lainnya: this.dokumen_lainnya,
      }

      await this.$store.dispatch('level1/setUpdateKbli', updateData)
      // await this.closeModal()
    },
    deleteItem() {
      if (confirm(`Menghapus: ${this.kode} - ${this.title}`)) {
        this.$store.dispatch('level1/deleteKbli', { id: this.id })
      } else {
        // Do nothing!
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
